import $ from 'jquery';
import React from "react";

const UrlDominio = window.location.host;

const year = new Date().getFullYear()
export const CRM = {
  sNombre: "CRM Plataforma para el Bienestar Empresarial N-035",
  sNombreCorto: "CRM Plataforma-N-035",
  sVersion: "1.0",
  sDerechos: "TODOS LOS DERECHOS RESERVADOS " + year + " TRASCENTI CONSULTING, S.A. DE C.V."
}

export const CMS = {
  //sUrl : 'http://localhost:49538/',
  //sUrl : 'http://187.189.192.199:8181/',
  //sUrl :'http://localhost:49538/',
  //https://democmsn035.azurewebsites.net/
  sUrl: (UrlDominio.indexOf("trascenti") != -1 || UrlDominio.indexOf("azurewebsites") != -1) ? 'https://norma035.eastus.cloudapp.azure.com/norma035backend/' : 'http://localhost:49538/',
  //sUrlPRD: 'https://back-cms-n-035.azurewebsites.net/'
  sUrlPRD: 'https://norma035.eastus.cloudapp.azure.com/norma035backend/'
}

// TABLES CONFIGURATION
export const TableDefaultOptions =
{
  paging: true, // Table pagination
  ordering: true, // Column ordering
  order: [],
  info: true, // Bottom left status text
  responsive: true,
  // Text translation options
  // Note the required keywords between underscores (e.g _MENU_)
  language: {
    sSearch: '<em class="fa fa-search"></em>',
    sLengthMenu: '_MENU_ registros por página',
    info: 'Mostrando página _PAGE_ de _PAGES_',
    zeroRecords: 'Ningún registro encontrado',
    infoEmpty: 'Sin registros disponibles',
    infoFiltered: '(filtrados de _MAX_ totales)',
    oPaginate: {
      sNext: '<em class="fa fa-caret-right"></em>',
      sPrevious: '<em class="fa fa-caret-left"></em>'
    }
  },
  // Datatable Buttons setup
  dom: 'Bfrtip',
  buttons: [
    //{ extend: 'copy', className: 'btn-info' },
    //{ extend: 'csv', className: 'btn-info' },
    { extend: 'excel', className: 'btn-info', title: 'XLS-File' , text: '<em class="far fa-file-excel"></em> Excel'},
    //{ extend: 'pdf', className: 'btn-info', title: $('title').text() },
    { extend: 'print', className: 'btn-info', text: '<em class="fas fa-print"></em> Imprimir'}
  ]
}

export const posSubMenu = () => {
    $(window).scroll(function() {
        if($(window).scrollTop() > 0){
            $("#submenuUp").css({
                "top": "80px",
                "position": "fixed"
            });
        }else{
            $("#submenuUp").removeAttr("style");
        }
    });
}

export const TableMUIDefaultOptions =
{
  body: {
    noMatch: "Ningún resultado encontrado",
    toolTip: "Ordenar",
    columnHeaderTooltip: column => `Ordenar por ${column.label}`
  },
  pagination: {
    next: "Siguiente página",
    previous: "Página anterior",
    rowsPerPage: "Filas por página:",
    displayRows: "de",
  },
  toolbar: {
    search: "Buscar",
    downloadCsv: "Exportar CSV",
    print: "Imprimir",
    viewColumns: "Ver columnas",
    filterTable: "Filtrar tabla",
  },
  filter: {
    all: "TODOS",
    title: "FILTROS",
    reset: "REINICIAR",
  },
  viewColumns: {
    title: "Ver columnas",
    titleAria: "Ver/esconder columnas",
  },
  selectedRows: {
    text: "columna(s) seleccionadas",
    delete: "Borrar",
    deleteAria: "Borrar fila",
  },
}

//TEMPLATE EMAILS
export const TiposTemplateEmails = {
  "APP TRIAL":
  '<div style="margin:5px; text-align: left;">'+
      '<h2>'+
          'Recibiste una invitación para probar la "Plataforma para el Bienestar '+
          'Empresarial N-035", prueba la aplicación TRIAL.'+
      '</h2>'+
      '<div>'+
          '<h2>'+
              'Sigue estos 5 pasos para acceder, aplicar y ver tus resultados según la NOM-035-STPS'+
          '</h2>'+
          '<div style="margin-left:10px">'+
              '<br/>'+
                  '1. Descarga la APP N-035 de la Play Store o App Store y registrate.'+
              '<br/>'+
                  '2. Entra a la Aplicación con tu mismo Usuario y Contraseña de registro.'+
              '<br/>'+
                  '3. Realiza la encuesta, no es necesario que la completes aunque se'+
                  'recomienda para conocer tu resultado particular según la Norma.'+
              '<br/>'+
                  '4. Consulta los Resultados (hay uno de muestra por si no hiciste o'+
                  'terminaste la encuesta).'+
              '<br/>'+
                  '5. Navegas en la APP para que veas todo lo que un trabajador puede hacer;'+
                  'Ver tus Notificaciones, Consultar Avisos de la Empresa, Reportar'+
                  'Incidencias (Buzón digital de Quejas), Consulta de la Política de la Empresa.'+
          '</div>'+
      '</div>'+
      '<br/>'+
      //'<div style="text-align: center;">'+
        //'<a href="#"><img style="height:50px; weight:auto;" '+
        //'src="http://www.trascenti.com/img/download_android_plataforma_n_035.png"/></a>'+
        //'<a href="#"><img style="height:50px; weight:auto;" '+
        //'src="http://www.trascenti.com/img/download_ios_plataforma_n_035.png"/></a>'+
      //'</div>'+
      //'<p>Descarga Android: <br/>https://play.google.com/store/apps/details?id=com.norma035</p>'+
      //'<p>Descarga IOS: <br/>https://apps.apple.com/app/id1489250091</p>'+
      //'<p>Ir a nuestro sitio para más información: <br/>http://www.trascenti.com/plataforma-norma-035</p>'+
    '</div>',

  "ENCUESTA TRIAL":
  '<div style="margin:5px; text-align: left;">'+
      '<h2>'+
          'Agradecemos haber probado la aplicación, estamos seguros que te gustará aún más, '+
          'ahora puedes concluir con la aplicación de tu encuesta, ¡entra a la aplicación ahora!'+
      '</h2>'+
      '<div>'+
          '<h2>'+
              'Inicia una encuesta de prueba en la aplicación:'+
          '</h2>'+
          '<div style="margin-left:10px">'+
              '<br/>'+
                  '1. Ve a tu aplicación de la Plataforma N-035 (Android o IOS).'+
              '<br/>'+
                  '2. Inicia sesión/Registrate.'+
              '<br/>'+
                  '3. Da clic en el botón "Realizar Encuesta Trial".'+
              '<br/>'+
                  '4. Realiza tu encuesta de prueba.'+
          '</div>'+
      '</div>'+
      '<br/>'+
      //'<div style="text-align: center;">'+
        //'<a href="#"><img style="height:50px; weight:auto;" '+
        //'src="http://www.trascenti.com/img/download_android_plataforma_n_035.png"/></a>'+
        //'<a href="#"><img style="height:50px; weight:auto;" '+
        //'src="http://www.trascenti.com/img/download_ios_plataforma_n_035.png"/></a>'+
      //'</div>'+
      //'<p>Descarga Android: <br/>https://play.google.com/store/apps/details?id=com.norma035</p>'+
      //'<p>Descarga IOS: <br/>https://apps.apple.com/app/id1489250091</p>'+
      //'<p>Ir a nuestro sitio para más información: <br/>http://www.trascenti.com/plataforma-norma-035</p>'+
    '</div>',

  "CMS TRIAL":
  '<div style="margin:5px; text-align: left;">'+
      '<h2>'+
          'Agradecemos haber probado la APP de la Plataforma para el '+
          'Bienestar Empresarial N-035, ahora te invitamos a conocer el '+
          'sitio WEB para la Gestión de las Encuestas y los Resultados que '+
          'se obtienen para la NOM-035-STPS.'+
      '</h2>'+
      '<div>'+
          '<h2>'+
              'Sigue estos 3 pasos para acceder, aplicar y ver los resultados según la NOM-035-STPS:'+
          '</h2>'+
          '<div style="margin-left:10px">'+
            '<br/>'+
            '1. Accede al sitio Web http: http://plataforman035.trascenti.com/login'+
            '<br/>'+
            '2. Entra con tu usuario y password con que te registraste en la APP.'+
            '<br/>'+
            '3. Navega por la Plataforma, observa el Tablero de Control y conoce su funcionalidad, además: '+
            '<br/>'+
          '</div>'+
          '<ul>'+
            '<li>'+
                'Revisa los Datos de tu Empresa y tus Trabajadores.'+
            '</li>'+
            '<li>'+
                'Activa y Configura tu Encuesta'+
            '</li>'+
            '<li>'+
                'Monitorea el avance de la Encuesta'+
            '</li>'+
            '<li>'+
                'Consulta los Reporte Oficiales de la NOM-035'+
            '</li>'+
            '<li>'+
                'Analiza la información de valor de tus Trabajadores'+
            '</li>'+
            '<li>'+
                'Revisa y da seguimiento a las Incidencias reportadas'+
            '</li>'+
            '<li>'+
                'Envía Mensajes o Notificaciones'+
            '</li>'+
            '<li>'+
                'Publica Avisos o Comunicados a tus Trabajadores'+
            '</li>'+
          '</ul>'+
      '</div>'+
      '<br/>'+
      '<div style="text-align: center;">'+
        '<a href="#"><img style="height:50px; weight:auto;" '+
        'src="http://www.trascenti.com/img/logo_plataforma_n_035.png"/></a>'+
      '</div>'+
      '<p>Empecemos: <br/>http://plataforman035.trascenti.com/login</p>'+
      '<br/>'+
      'Estamos a tus ordenes.'+
    '</div>',

  "MAS INFO":
  '<div style="margin:5px; text-align: left;">'+
      '<h2>'+
          'Sabemos que las empresas de la actualidad requieren cumplir '+
          'con la Norma 035 además del bienestar de sus trabajadores, y la '+
          'Plataforma para el Bienestar Empresarial N-035 te ayudará hacerlo.'+
      '</h2>'+
      '<div>'+
        '<div>'+
          '<img style="height:500px; weight:550px;" '+
          'src="http://www.trascenti.com/img/ficha_producto_nom_035.png">'+
        '</div>'+
      '</div>'+
      '<br/>'+
      //'<p>Más información: <br/>http://www.trascenti.com/plataforma-norma-035</p>'+
      '<br/>'+
      'Estamos a tus ordenes.'+
    '</div>'
}
